#meetingName{
  color: black;
  font-family: "ArtifaktElementBold";
  cursor: pointer;
}

#meeting-control-container{
  background-color: white;
  width: 100%;
  margin-top: 10px;
}

#meeting-control-toolbar {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap-reverse;
  align-items: center;
}

#control-buttons {
  display: flex;
  flex-direction: row;
}

/* #start-button {
  color: blueviolet;
} */


/* .control_buttons{
  margin-left: auto;
  margin-right: 150;
  margin-top: 0;
  margin-bottom: 5px;
  display: inline-flex;

} */
#no-archive-message {
  cursor: default;
  color: #a0a0a1;
  font-size: 12pt;
  margin: 10px;
}

#menuHeader{
  text-align: center;
  font-weight: bold;
  margin: 10px;
  cursor: default;
  color: #a0a0a1;
  font-size: 15pt;
  /* background-color:rgb(230,230,230) */
}


/* #editable-value {
  margin-left: 20px;
  margin-right: 20px;
} */

/* @font-face {
    font-family: 'ArtifaktElementBold';
    src:url('https://fonts.autodesk.com/ArtifaktElement/WOFF2/Artifakt%20Element%20Bold.woff2') format('woff2');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
}

#MUIheader{
    height: 50px;
}

.container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 1rem 0 1rem 0;
}

.control_buttons{
  margin-left: auto;
  margin-right: 150;
  margin-top: 0;
  margin-bottom: 5px;
  display: inline-flex;

}

#timePicker{
  font-family: "ArtifaktElementBold";
}

.title {
    font-size: 30px;
    flex: 1 1;
    font-weight: bolder;
}

.subtitle {
    font-size: 20px;
    font-weight: bolder;
}

.text {
    font-size: 20px;
    font-weight: bolder;
    text-align: right;
}

.dateTimeContainer {
    display: flex;
    flex-direction: column;
}

#meetingName{
    color: black;
    font-family: "ArtifaktElementBold";

}
#meetingLengthPopupText{
    font-family: "ArtifaktElementBold";
    font-size: large;
}
#meetingLengthTextField{
   width: 80px;
   font-family: "ArtifaktElementBold";
}
#meetingLengthPopup{
    padding-bottom: 10px;
}
#meetingLengthPopupTitle{
    font-family: 'ArtifaktElementBold';
    padding-bottom: 8px;
}
#debugError{
    color: red;
    font-family: 'ArtifaktElementBold';
    padding-left: 15.5px;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button { 
	-webkit-appearance: none;
}

#activeMeetingsMenuItem{
    padding-bottom: 30px;
}
#archiveConfirmationButtons{
    display: flex;
    justify-content: center;
    padding-top: 10px;
}
#archiveButton{
    margin-right: 10px;
    align-self: flex-end;
}
#archivePrompt1{
    text-align: center;
    font-weight: bold;
}
#archivePrompt2{
    text-align: center;
} */